import { computed, ref, Ref } from 'vue';
import { LoadingStatuses } from '@/models/loading.interface';
import store from '@/store';

export default class SearchInputCode {
	public tableEntitiesSearchInput: Ref<HTMLInputElement | null> = ref(null);
	public searchTerm: Ref<string> = ref('');
	public searchWrapper = ref<HTMLDivElement | null>(null);
	private debounceDelay = 1000;

	private debounceTimeout: NodeJS.Timeout | number | null = null;

	public isLoading = computed((): boolean => {
		const loadingStatus =  store.getters.loadingStatusEntities();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public setSearchTerm(): void {
		if (this.tableEntitiesSearchInput.value === null) {
			return;
		}

		this.searchTerm.value = this.tableEntitiesSearchInput.value.value;

		if (this.searchTerm.value.trim() === '') {
			this.delayedFunction();
			return;
		}

		this.debounceSearch();
	}

	private debounceSearch(): void {
		if (this.debounceTimeout) {
			clearTimeout(this.debounceTimeout as NodeJS.Timeout);
		}

		this.debounceTimeout = setTimeout(
			this.delayedFunction.bind(this),
			this.debounceDelay
		);
	}

	private delayedFunction(): void {
		store.mutations.setEntitySearchQuery(
			this.searchTerm.value.trim()
		);
	}
}
